import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

const isProd = import.meta.env.PROD;
const defaultLevel = isProd ? 'warn' : 'debug';

// Initialize loglevel
log.setLevel(defaultLevel);

// Configure prefix
prefix.reg(log);
prefix.apply(log, {
  template: '[%t] %l (%n):',
  levelFormatter(level) {
    return level.toUpperCase();
  },
  nameFormatter(name) {
    return name || 'global';
  },
  timestampFormatter(date) {
    return date.toISOString();
  }
});

// Create a logger factory
export function createLogger(name: string) {
  const namedLogger = log.getLogger(name);
  // Inherit the root level unless localStorage override exists
  try {
    const savedLevel = localStorage.getItem('log_level');
    if (savedLevel && Object.values(LogLevel).includes(savedLevel as LogLevel)) {
      namedLogger.setLevel(savedLevel as log.LogLevelDesc);
    }
  } catch {
    // Ignore localStorage errors
  }
  return namedLogger;
}

// Export the root logger for global use
export const logger = log;

// Export log levels for convenience
export const LogLevel = {
  TRACE: 'trace',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
} as const;

export type LogLevel = typeof LogLevel[keyof typeof LogLevel];

// Helper to set log level (can be called from browser console for debugging)
export function setLogLevel(level: LogLevel) {
  log.setLevel(level as log.LogLevelDesc);
  try {
    localStorage.setItem('log_level', level);
  } catch {
    // Ignore localStorage errors
  }
}

// Check for localStorage override on startup
try {
  const savedLevel = localStorage.getItem('log_level');
  if (savedLevel && Object.values(LogLevel).includes(savedLevel as LogLevel)) {
    setLogLevel(savedLevel as LogLevel);
  }
} catch {
  // Ignore localStorage errors
} 